export const sunSetPerks = {
    "Perks": [
       {"identifier": "R3554",'modalTitle' : 'You want to remove Walmart +?' ,'modalContent':'Walmart+ will be removed once your current subscription cycle ends. It will not be available for purchase again thereafter.'},
       {"identifier": "R3551",'modalTitle' : 'You want to remove +play?' ,'modalContent':'Your $15 of monthly +play credits will be removed after the last day of your perk subscription period. +play credits will not be available for purchase again thereafter.'},
       {"identifier": "R3558",'modalTitle' : 'You want to remove the Disney Bundle?' ,'modalContent':'The Disney Bundle will be removed once your current subscription cycle ends. It will not be available for purchase again thereafter.'},
       

    ]
}